"use strict";

define('view/study/submission.tab',['require','exports','module','underscore','../page.list','langs'],function (require, exports, module) {
  var _ = require('underscore');
  var PageListView = require('../page.list');
  var langs = require('langs');
  var SubmissionDetailView = PageListView.extend({
    options: {
      search: false,
      header: false,
      useTableHeader: true,
      hideTableHeaderFromScreens: true,
      tableHeaderText: langs.phrase('StudiesPage.Submissions.TableHeaderText'),
      tableHeaderLevel: '2',
      tableHeaderId: 'submissionTypeHeader'
    },
    initialize: function initialize(options) {
      PageListView.prototype.initialize.apply(this, arguments);
      this._initializeTableView();
    },
    _initializeTableView: function _initializeTableView() {
      this.table.compact = false;
      this.table.padded = true;
      this.table.sortable = false;
      this.table.selectable = true;
      this.table.basic = true;
      this.table.ariaLabelledby = this.getOption('tableHeaderId');
      this.table.emptyText = 'No Submissions';
    }
  });
  module.exports = SubmissionDetailView;
});

